import { render, staticRenderFns } from "./format8.vue?vue&type=template&id=3dd9e03b&"
import script from "./format8.vue?vue&type=script&lang=ts&"
export * from "./format8.vue?vue&type=script&lang=ts&"
import style0 from "./format8.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports